import { UIHeading4, LinkButton, IconMap16 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Container } from '../../components/Container';
import { SIZE_16 } from '../../constants/sizes';

import { getSubtitle } from '../../selectors/seo';
import { getMapFullUrl } from '../../selectors/offersData';

export const OffersHeaderContainer = () => {
  const subtitle = useSelector(getSubtitle);
  const mapFullUrl = useSelector(getMapFullUrl);

  return (
    <Container
      backgroundColor="white"
      dataMark="OffersHeader"
      columnGap={SIZE_16}
      padding="25px 0 0 0"
      display="flex"
      alignItems="center"
      noPrint
    >
      <UIHeading4>{subtitle}</UIHeading4>

      {mapFullUrl && (
        <Container display="inline-flex" tagName="noindex" noPrint>
          <LinkButton
            href={mapFullUrl}
            target="_blank"
            size="XS"
            theme={'fill_white_primary'}
            beforeIcon={<IconMap16 color="primary_100" />}
            data-testId="MapLink"
          >
            На карте
          </LinkButton>
        </Container>
      )}
    </Container>
  );
};
